import { useField } from "formik";

import "../Forms.scss";

function Radio({ name, value, label, className }) {
  const [field, , helpers] = useField(name);

  function handleCheck() {
    helpers.setValue(value);
    helpers.setTouched(true);
  }

  return (
    <div className={`radio-field ${className}`}>
      <input
        type="radio"
        name={name}
        id={name}
        value={value}
        checked={field.value === value}
        onChange={handleCheck}
      />

      <div onClick={handleCheck} className="checkmark"></div>

      <label htmlFor={name}>{label}</label>
    </div>
  );
}

export default Radio;
